import { type SASearchFormFields, SearchTypesSP } from "../components/SearchCard/SalesPartnerSearchBox";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { SearchParamBuilder } from "~/utils/searchParamBuilder";

export interface InputsData extends SASearchFormFields {
  countryCode: string;
}

export type UrlParams = Pick<
  InputsData,
  | "partner"
  | "address"
  | "radius"
  | "countryCode"
  | "searchType"
  | "filterByCountry"
  | "productCompetence"
  | "certifiedCompetence"
> & {
  preferredSalesPartner?: string;
  lat?: number;
  lng?: number;
  salesPartnerId?: string;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSalesPartnerSearch(
  inputsData: UrlParams,
  pageNumber?: number,
  abortSignal?: AbortSignal,
): Promise<any> {
  const url = createUrlFromInputValues(inputsData, pageNumber);
  return fetch(url, {
    method: "GET",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
    signal: abortSignal,
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
}

export function createUrlFromInputValues(inputsData: UrlParams, pageNumber?: number): string {
  const builder = new SearchParamBuilder();

  builder.setIfDefined("searchType", inputsData.searchType);

  if (inputsData.searchType === SearchTypesSP.Partner) {
    builder.setIfDefined("q", inputsData.partner);
  } else {
    builder.setIfDefined("q", inputsData.address);
    if (inputsData.radius !== -1) {
      builder.setIfDefined("radius", inputsData.radius);
    }
  }

  builder.setIfDefined("latitude", inputsData.lat);
  builder.setIfDefined("longitude", inputsData.lng);

  if (inputsData.filterByCountry) {
    builder.setIfDefined("country", inputsData.countryCode);
  }

  builder.setIfDefined("preferredSalesPartner", inputsData.salesPartnerId);
  builder.setIfDefined("page", pageNumber);

  builder.appendArrayParam("productCompetence", inputsData.productCompetence);
  builder.appendArrayParam("certifiedCompetence", inputsData.certifiedCompetence);

  return resolveApiUrl(`/store-finder/search?${builder.toString()}`);
}
